<script setup>
  import { defineProps, inject } from 'vue'
  import BaseCard from "../components/BaseCard.vue";

  const isDarkMode = inject('isDarkMode')

  const props = defineProps({
    tool: String,
  })

  const toolNames = {
    'movelist-generator': "Pokémon Movelist Generator",
    'typing-analyser': "Pokémon Typing Analyser",
    'stat-jiggler': "Pokémon Stat Jiggler",
  }
  const toolAltText = {
    'movelist-generator': "An illustration of a Porygon deciding on moves.",
    'typing-analyser': "An illustration of Bulbasaur, Charmander and Squirtle playing.",
    'stat-jiggler': "An illustration of a Deoxys in front of a stat-distribution graph.",
  }
  const toolDescriptions = {
    'movelist-generator': "Generate movelists for your Pokémon based on type, bodyshape, and more.",
    'typing-analyser': "Analyse the strengths and weaknesses of a Pokémon typing.",
    'stat-jiggler': "Generate a Pokémon's power level and primary stats.",
  }

</script>
<template>
  <div class="flex flex-col lg:flex-row-reverse gap-8">

    <div class="lg:max-w-[33%] flex flex-col gap-4">
      <BaseCard :tool="props.tool" class="!p-0 overflow-hidden ">
        <img
            :src="isDarkMode
              ? $router.options.base+'/images/tools/'+props.tool+'-dark.jpg'
              : $router.options.base+'/images/tools/'+props.tool+'.jpg'
            "
            class="w-full display-block"
            :alt="toolAltText[props.tool]"
          />
      </BaseCard>

      <div class="text-right">
        <slot name="controls"/>
      </div>
    </div>

    <div class="flex-grow">
      <h1 class="text-4xl mb-4">{{toolNames[props.tool]}}</h1>
      <h2 :class="'text-2xl mb-12 text-tool-'+props.tool">{{toolDescriptions[props.tool]}}</h2>

      <slot name="info"/>
    </div>
  </div>
</template>
